import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownExtraServiceAdditionalOptions', request)
}

export {get}
